"use strict";

exports.__esModule = true;
exports.composeDataLayer = void 0;

var _staticValues = require("./staticValues");

// TODO: replace with dynamic loading when rollup is fixed or different build mechanism

/**
 * Loads datalayer set-up
 *  @todo needs refactoring for the same reason as whoami (dynamic loading and separation of config)
 *
 * @param {*} id
 * @returns datalayer object
 */
const loadConfig = id => {
  switch (id) {
    default:
      return { ..._staticValues.config
      };
  }
};
/**
 * this composes the datalayer for a brand - env configuration
 *  @todo needs refactoring for the same reason as whoami
 *
 */


const composeDataLayer = whoami => {
  const cfg = loadConfig(whoami.profile);
  return { ...cfg,
    ...whoami.dataLayer
  };
};

exports.composeDataLayer = composeDataLayer;